import { PageLoader } from '../components/ui';
import { type ReactNode, Suspense } from 'react';

export { PageLoader };

export function LazyPage({ children }: { children: ReactNode }) {
  return (
    <Suspense fallback={<PageLoader fullHeight={false} />}>{children}</Suspense>
  );
}
